/**
 * Lokalni kopie klasifikace zdroje odpovedi (BLOK 10) — MUSI zustat shodna s
 * @reos/duediligence public/answer-question.ts (overuje answer-source.spec.ts
 * porovnanim se skutecnym balickem pro vsechny ANSWER_SOURCE_KINDS).
 *
 * Duvod duplikace: web-admin smi z @reos/duediligence importovat jen TYPY
 * (`import type`, erasovane pri kompilaci). Balicek nema "sideEffects": false
 * a jeho jediny vstupni bod (dist/index.js) re-exportuje i server-only kod
 * (napr. trust/persist.js -> @reos/observability -> node:async_hooks) —
 * runtime import odsud rozbiji prohlizecovy build Vite/Rollup (`AsyncLocalStorage
 * is not exported by __vite-browser-external`).
 */
import type { AnswerSourceKind } from '@reos/duediligence';

export const ANSWER_SOURCE_KINDS: readonly AnswerSourceKind[] = ['CLIENT_STATEMENT', 'AUTHORITY_STATEMENT', 'DOCUMENT', 'BROKER_FINDING'];

const DECLARATIVE_SOURCES = new Set<AnswerSourceKind>(['CLIENT_STATEMENT', 'BROKER_FINDING']);

/** Bez zpusobileho dukazu (LV, vyjadreni spravce, ...) — jen tvrzeni. */
export function isDeclarativeAnswerSource(source: AnswerSourceKind): boolean {
  return DECLARATIVE_SOURCES.has(source);
}

/** Jen doloženy dokument nebo vyjádření úřadu/správce muze zavrit kritickou branu (D5). */
export function canAnswerSourceCloseGate(source: AnswerSourceKind): boolean {
  return !isDeclarativeAnswerSource(source);
}
